import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bf7zwxbsts: FaireBrandEntity = {
  token: "b_bf7zwxbsts",
  type: "brand",
  name: "Dandylion",
  avatarUrl: "https://cdn.faire.com/fastly/b5af4fc22c8ca36e207239041797ccd16ff9efbf22bb539bbac367e46aa6326d.png",
  bannerUrl: "https://cdn.faire.com/fastly/1fb87c4a2b2b2dc496231ae8bc9f017cf26fd2a8aca335a491f0f4526955c688.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/b5af4fc22c8ca36e207239041797ccd16ff9efbf22bb539bbac367e46aa6326d.png",
  heroImageUrl: "https://cdn.faire.com/fastly/1fb87c4a2b2b2dc496231ae8bc9f017cf26fd2a8aca335a491f0f4526955c688.jpeg",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 29,
  isTopShop: true,
  isInsider: false,
  description: "At Dandylion, we’re building the next generation of routine dog care essentials to help dog parents manage itchy skin issues, and promote health & wellness from the outside in.\n\nDandylion creates skin-friendly & irritant-free products with input from vet-dermatologists, expert chemists and dog parents. Products are formulated with plant ingredients and designed to soothe & nourish the skin. \n\nDUTIES INCLUDED. ",
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:13:36.963Z",
    importedBy: "entity-db-cli"
  }
};
